import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export const OpenFrameLogo = ({
  className,
  lowerPathColor,
  upperPathColor,
  ...props
}: { className?: string; lowerPathColor?: string; upperPathColor?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={
        {
          '--fill-0': 'currentColor',
          ...props.style,
        } as React.CSSProperties
      }
    >
      <g>
        <g>
          {/* White squares - top right, bottom left, bottom right, bottom center */}
          <path
            d="M21.3333 16.5333C21.3333 16.2388 21.5721 16 21.8667 16H26.1333C26.4279 16 26.6667 16.2388 26.6667 16.5333V20.8C26.6667 21.0946 26.4279 21.3333 26.1333 21.3333H21.8667C21.5721 21.3333 21.3333 21.0946 21.3333 20.8V16.5333Z"
            fill={lowerPathColor ?? '#ffffff'}
          />
          <path
            d="M16 21.8667C16 21.5721 16.2388 21.3333 16.5333 21.3333H20.8C21.0946 21.3333 21.3333 21.5721 21.3333 21.8667V26.1333C21.3333 26.4279 21.0946 26.6667 20.8 26.6667H16.5333C16.2388 26.6667 16 26.4279 16 26.1333V21.8667Z"
            fill={lowerPathColor ?? '#ffffff'}
          />
          <path
            d="M26.6667 21.8667C26.6667 21.5721 26.9054 21.3333 27.2 21.3333H31.4667C31.7612 21.3333 32 21.5721 32 21.8667V26.1333C32 26.4279 31.7612 26.6667 31.4667 26.6667H27.2C26.9054 26.6667 26.6667 26.4279 26.6667 26.1333V21.8667Z"
            fill={lowerPathColor ?? '#ffffff'}
          />
          <path
            d="M21.3333 27.2C21.3333 26.9054 21.5721 26.6667 21.8667 26.6667H26.1333C26.4279 26.6667 26.6667 26.9054 26.6667 27.2V31.4667C26.6667 31.7612 26.4279 32 26.1333 32H21.8667C21.5721 32 21.3333 31.7612 21.3333 31.4667V27.2Z"
            fill={lowerPathColor ?? '#ffffff'}
          />
        </g>
        {/* Black frame/border */}
        <path
          d="M30.9333 0H1.06667C0.477563 0 0 0.477564 0 1.06667V30.9333C0 31.5224 0.477563 32 1.06667 32H14.9333C15.5224 32 16 31.5224 16 30.9333V27.7333C16 27.1442 15.5224 26.6667 14.9333 26.6667H5.86667C5.57211 26.6667 5.33333 26.4279 5.33333 26.1333V5.86667C5.33333 5.57211 5.57211 5.33333 5.86667 5.33333H26.1333C26.4279 5.33333 26.6667 5.57212 26.6667 5.86667V14.9333C26.6667 15.5224 27.1442 16 27.7333 16H30.9333C31.5224 16 32 15.5224 32 14.9333V1.06667C32 0.477563 31.5224 0 30.9333 0Z"
          fill={upperPathColor ?? '#1A1A1A'}
        />
      </g>
    </svg>
  );
};
